import { gql } from '@apollo/client';

export const FR_COMPONENT_FIELDS = gql`
    fragment fr_ComponentFields on Component {
        ComponentId
        Assembly {
            AssemblyId
        }
        Code
        Name
        sv_name: Name(LangCode: SV)
        en_name: Name(LangCode: EN)
        no_name: Name(LangCode: NO)
    }
`;
